module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.3.7-235.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.3.7.md
// module id = 678
// module chunks = 298